import { normalizeUpgradeContext } from './upgradeContext';

export const buildUpgradeTrackingProperties = (upgradeContext, properties = {}) => {
    const normalized = normalizeUpgradeContext(upgradeContext);

    return {
        target_plan: 'pro',
        intent: 'pro_upgrade',
        upgrade_source: normalized?.source,
        upgrade_feature: normalized?.feature,
        upgrade_path: normalized?.path,
        upgrade_notice_id: normalized?.noticeId,
        upgrade_source_system: normalized?.sourceSystem,
        ...properties,
    };
};

export const buildPlanTrackingProperties = (plan, properties = {}) => ({
    plan_id: plan?.id,
    plan_name: plan?.name,
    plan_type: plan?.planType,
    billing_interval: plan?.billingInterval,
    price: plan?.price,
    currency: plan?.currency,
    ...properties,
});

export const buildCheckoutTrackingProperties = (plan, upgradeContext, properties = {}) => ({
    ...buildUpgradeTrackingProperties(upgradeContext, {
        intent: 'pro_checkout',
    }),
    ...buildPlanTrackingProperties(plan),
    ...properties,
});
